export default function useColPocketTextSchema({ accessor, title }) {
    const colPocketTitleSchema = {
        accessor,
        title,
    };

    return colPocketTitleSchema;
}
